export const ASSIGNMENT_IS_TOO_BIG_FOR_DISCOVERY = '(Assignment is too big for discovery)'
export const ASSIGNMENT_IS_TOO_BIG_FOR_PROJECTION = '(Assignment is too big for projection)'
